import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';

const STORAGE_KEY = 'gs-values-hidden';

interface ValueVisibilityContextType {
    hidden: boolean;
    toggle: () => void;
}

const ValueVisibilityContext = createContext<ValueVisibilityContextType>({
    hidden: true,
    toggle: () => {},
});

export const ValueVisibilityProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [hidden, setHidden] = useState<boolean>(() => {
        try {
            const stored = localStorage.getItem(STORAGE_KEY);
            // If no value stored yet, default to true (hidden).
            return stored === null ? true : stored === 'true';
        } catch {
            return true;
        }
    });

    useEffect(() => {
        try {
            localStorage.setItem(STORAGE_KEY, String(hidden));
        } catch { /* ignore */ }
    }, [hidden]);

    const toggle = useCallback(() => setHidden((v) => !v), []);

    return (
        <ValueVisibilityContext.Provider value={{ hidden, toggle }}>
            {children}
        </ValueVisibilityContext.Provider>
    );
};

export function useValueVisibility(): ValueVisibilityContextType {
    return useContext(ValueVisibilityContext);
}
